<template>
  <div>
    <button
      type="button"
      class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold cursor-pointer bg-transparent border-0"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <i class="fas fa-truck text-lg leading-lg mr-2 text-amber-300"></i>
      WaveCommand
      <i class="fas fa-chevron-down ml-1 text-xs"></i>
    </button>
    <div
      ref="popoverDropdownRef"
      class="nav-dropdown-menu bg-blueGray-800 text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48 border border-blueGray-700"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <router-link
        to="/wavecommand7"
        class="text-sm py-2 px-4 font-semibold block w-full whitespace-nowrap bg-transparent text-lightBlue-300 hover:bg-blueGray-700 hover:text-white"
        @click="closeDropdown"
      >
        WaveCommand7
      </router-link>
      <router-link
        to="/mpc"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-200 hover:bg-blueGray-700 hover:text-white"
        @click="closeDropdown"
      >
        Datavan MPC
      </router-link>
      <router-link
        to="/dvcommand"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-200 hover:bg-blueGray-700 hover:text-white"
        @click="closeDropdown"
      >
        DVCommand
      </router-link>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    closeDropdown() {
      this.dropdownPopoverShow = false;
    },
  },
};
</script>
